import { jsx as _jsx } from "react/jsx-runtime";
import Stack from '@mui/material/Stack';
import AccountListItem from '@themes/account/components/ListItem';
const OtherOrders = ({ customerOrderInvoice }) => {
    var _a, _b, _c;
    const customerOrder = customerOrderInvoice === null || customerOrderInvoice === void 0 ? void 0 : customerOrderInvoice.businessContactOrder;
    return (_jsx(Stack, Object.assign({ sx: { marginBottom: 4 }, component: 'ul' }, { children: (_c = (_b = (_a = customerOrder === null || customerOrder === void 0 ? void 0 : customerOrder.rows) === null || _a === void 0 ? void 0 : _a.filter((item) => item.parentRowId)) === null || _b === void 0 ? void 0 : _b.sort((a, b) => (a.position || 0) - (b.position || 0))) === null || _c === void 0 ? void 0 : _c.map((item) => {
            var _a, _b;
            let text = (_b = (item.additionalRowDescription || ((_a = item.part) === null || _a === void 0 ? void 0 : _a.description) || item.freeText)) === null || _b === void 0 ? void 0 : _b.trim();
            if (text === null || text === void 0 ? void 0 : text.startsWith('-')) {
                text = text.substring(1);
            }
            return _jsx(AccountListItem, { children: text }, item.id);
        }) })));
};
export default OtherOrders;
